// table-columns
import i18n from '@/lang';

export const columns = [
  // 客户名称
  { prop: 'customerName', label: i18n.t('basicData.CustomerName'), width: 180, align: 'left' },
  // 客户单号
  { prop: 'customerNumber', label: i18n.t('receivablePayable.CustomerTrackingNumber'), width: 180, align: 'left' },
  // 订单号
  { prop: 'orderNumber', label: i18n.t('basicData.OrderNumber'), width: 180, align: 'left' },
  // 业务单号
  {
    prop: 'waybillNumber',
    label: i18n.t('receivablePayable.TicketNumber'),
    width: 180,
    align: 'left'
  },
  // 业务类型
  {
    prop: 'businessTypeName',
    label: i18n.t('collectionCenter.businessT'),
    width: 160,
    align: 'left'
  },
  // 金额
  { prop: 'estimateAmount', label: i18n.t('basicData.Amount'), width: 130, align: 'left' },
  // 资金状态
  { prop: 'statusName', label: i18n.t('basicData.FundStatus'), width: 160, align: 'left' },
  // 来源
  { prop: 'moneySourceName', label: i18n.t('mdfeTranslate.source'), width: 160, align: 'left' },
  // 创建时间
  { prop: 'createTime', label: i18n.t('basicData.CreationTime'), width: 160, align: 'left' },
  // 更新时间
  { prop: 'updateTime', label: i18n.t('GlobalSetObj.UpdateTime'), width: 160, align: 'left' }
];

// 资金状态
export const STATUS = [
  // {
  //   value: 1,
  //   label: i18n.t('basicData.PreOccupied')
  // },
  {
    value: 2,
    label: i18n.t('basicData.Released')
  },
  {
    value: 3,
    label: i18n.t('basicData.AmountDeducted')
  },
  {
    value: 4,
    label: i18n.t('basicData.DeductionFailed')
  }
  // {
  //   value: 5,
  //   label: i18n.t('basicData.PreDeductionFailed')
  // }
];

export const BUSINESS_TYPE = [
  {
    label: i18n.t('receivablePayable.ExpressSystemBusinessFirstLeg'), // 快递-头程
    value: 0
  },
  {
    label: i18n.t('receivablePayable.CollectionSystemBusiness'), // 揽收
    value: 1
  },
  {
    label: i18n.t('receivablePayable.ExpressSystemBusinessLastLeg'), // 快递-尾程
    value: 2
  }
];
